export enum BusinessTypeEnum {
  PUBLIC_DISTRICT = 'publicDistrict',
  CHARTER_SCHOOL = 'charterSchool',
  PRIVATE_SCHOOL = 'privateSchool',
}
